import React from 'react';
import PriceLabel from '@prisjakt/ui-price-label';

import * as S from './styles';

type ListPriceProps = {
  price?: number | null;
  quantity: number;
};

const ListPrice = ({ price, quantity }: ListPriceProps) => {
  if (!price) return null;

  return (
    <S.ListPrice>
      <S.CurrentPrice>
        <PriceLabel value={price} />
      </S.CurrentPrice>

      {quantity !== 1 && <S.Quantity>x{quantity}</S.Quantity>}
    </S.ListPrice>
  );
};

export default ListPrice;
